export const partnerFlagsTranslation = {
  notification: {
    canNotBePast: 'partnerflags-notification-can-not-be-past',
    canNotBePresent: 'partnerflags-notification-can-not-be-present',
    deleteRequestDate: 'partnerflags-notification-delete-request-date',
  },
  cover: {
    status: 'partnerflags-cover-status',
    action: 'partnerflags-cover-action',
    expiry: 'partnerflags-cover-expiry',
  },
  content: {
    statusWarning: 'partnerflags-content-request-in-progress',
    field: {
      codeName: 'partnerflags-content-field-code_name',
      code: 'partnerflags-content-field-code',
      startDate: 'partnerflags-content-field-start_date',
      endDate: 'partnerflags-content-field-end_date',
      signatureDate: 'partnerflags-content-field-signature_date',
      comment: 'partnerflags-content-field-comment',
    },
    btn: {
      apply: 'partnerflags-content-btn-apply',
      delete: 'partnerflags-content-btn-delete',
      deleteRequest: 'partnerflags-content-btn-delete_request',
    },
    confirm: {
      update: {
        title: 'partnerflags-content-confirm-update-title',
        content: 'partnerflags-content-confirm-update-title',
        btn: {
          apply: 'partnerflags-content-confirm-update-btn-apply',
          reject: 'partnerflags-content-confirm-update-btn-reject',
        },
      },
      delete: {
        title: 'partnerflags-content-confirm-delete-title',
        content: 'partnerflags-content-confirm-delete-title',
        btn: {
          apply: 'partnerflags-content-confirm-delete-btn-apply',
          reject: 'partnerflags-content-confirm-delete-btn-reject',
        },
      },
    },
  },
  panel: {
    field: {
      search: 'partnerflags-panel-field-search',
    },
    btn: {
      addNew: 'partnerflags-panel-btn-add_new',
    },
  },
  empty: {
    title: 'partnerflags-empty-title',
  },
}
